import { render } from "./Sorter.vue?vue&type=template&id=3fd8c014&scoped=true"
import script from "./Sorter.vue?vue&type=script&lang=js"
export * from "./Sorter.vue?vue&type=script&lang=js"

import "./Sorter.vue?vue&type=style&index=0&id=3fd8c014&scoped=true&lang=css"

import exportComponent from "/home/ad5hitotsuki/hitotsuki.net/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd8c014"]])

export default __exports__